import React, { useState, useEffect } from "react";
import "./Management.css";
import { Menu } from "antd";
import LoanOfficers from "./LoanOfficers";
import Borrowers from "./Borrowers";
import Pipeline from "./Pipeline";
import Integration from "./Integration";
import Customization from "./Customization/Customization";
import Lenders from "./Lenders";
import CommunicationSetup from "./CommunicationSetup/CommunicationSetup";
import CreditReportSettings from "./CreditReportSettings";
import SampleRatesConfig from "./SampleRatesConfig/SampleRatesConfig";
import { checkAccess } from "../Auth";
import UserManagement from "./userManagement";
import PlanPricing from "./planPricing";
import { UR_Owner, UR_LoanOfficerManager } from "../State";
import BillingManagement from './billingManagement'
import CallReports from "./CallReports/CallReports";
import "./Fixes.css";
import { useLocation } from 'react-router-dom';
import GMCCProgramEngine from "../GMCCCalculator/GMCCProgramEngine";
import GMCCFlyersHub from "../GMCCCalculator/FlyersHub/FlyersHub";
import RateQuote from "../Tools/MortgageCalculators/RateQuote";
import GMCCUniverseCalculator from "../Tools/MortgageCalculators/GMCCUniverseCalculator";
import GMCCDiamond from "../GMCCCalculator/GMCCDiamond";
import FlyerRatesSetup from "../GMCCCalculator/FlyerRatesSetup";
import EncompassSetup from "../GMCCCalculator/EncompassSetup";

const ManagementIcon = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.825 15.9H15.9V18.825C15.9 19.3632 16.3368 19.8 16.875 19.8H18.825C19.3632 19.8 19.8 19.3632 19.8 18.825V16.875C19.8 16.3368 19.3632 15.9 18.825 15.9ZM19.8 8.1V5.175C19.8 4.6368 19.3632 4.2 18.825 4.2H16.875C16.3368 4.2 15.9 4.6368 15.9 5.175V8.1H19.8ZM10.05 10.05H13.95V13.95H10.05V10.05ZM7.125 4.2H5.175C4.6368 4.2 4.2 4.6368 4.2 5.175V7.125C4.2 7.6632 4.6368 8.1 5.175 8.1H8.1V5.175C8.1 4.6368 7.6632 4.2 7.125 4.2ZM4.2 16.875V18.825C4.2 19.3632 4.6368 19.8 5.175 19.8H7.125C7.6632 19.8 8.1 19.3632 8.1 18.825V15.9H5.175C4.6368 15.9 4.2 16.3368 4.2 16.875ZM19.8 21.75H15.9C14.8226 21.75 13.95 20.8774 13.95 19.8V15.9H10.05V19.8C10.05 20.8774 9.17738 21.75 8.1 21.75H4.2C3.12262 21.75 2.25 20.8774 2.25 19.8V15.9C2.25 14.8226 3.12262 13.95 4.2 13.95H8.1V10.05H4.2C3.12262 10.05 2.25 9.17737 2.25 8.1V4.2C2.25 3.12263 3.12262 2.25 4.2 2.25H8.1C9.17738 2.25 10.05 3.12263 10.05 4.2V8.1H13.95V4.2C13.95 3.12263 14.8226 2.25 15.9 2.25H19.8C20.8774 2.25 21.75 3.12263 21.75 4.2V8.1C21.75 9.17737 20.8774 10.05 19.8 10.05H15.9V13.95H19.8C20.8774 13.95 21.75 14.8226 21.75 15.9V19.8C21.75 20.8774 20.8774 21.75 19.8 21.75Z"
      fill="#474849"
    />
  </svg>
);

function getItem(label, key, icon, children, type) {
  const labelWithTitle =
    typeof label === "string" ? <span title={label}>{label}</span> : label;
  return { key, icon, children, label: labelWithTitle, type };
}


const items = [
  getItem(
    <div
      style={{
        fontSize: 20,
        paddingLeft: 5,
        paddingTop: 10,
        display: "flex",
        alignItems: "center",
        color: "#474849",
        minWidth:"250px"
      }}>
      <ManagementIcon />
      <div className="ml-2">GMCC Specials <br /> (AI Lite Marketing)</div>
    </div>,
    "1",
    null,
    [
      getItem("Program maps", "programengine"), 
      getItem("Flyers hub", 'gmcc_flyers_hub', null, [
        getItem("Luxury open house", "gmcc_flyers_hub_openhouse", null, [
          getItem("Asset as income", "gmcc_flyers_hub_asset", null, [
            getItem("GMCC - Celebrity", "gmcc_asset_as_income"),
            getItem("GMCC - Neptune", "gmcc_neptune"),
            getItem("GMCC - Mercury", "gmcc_mercury"),
          ]),
          getItem("GMCC - Universe", "gmcc_universe"),
          getItem("GMCC - Massive", "gmcc_massive"),
          getItem("GMCC - Radiant (No income doc)", "gmcc_radiant_no_income_doc"),
          getItem("GMCC - Diamond AUS ($10M)", "gmcc_diamond_aus"),
          getItem("GMCC - Buy without sell first", "gmcc_buy_without_sell_first"),
          getItem("GMCC - 10% Bank statement ($3M)", "gmcc_10percent_bank_statement"),
        ]),
        getItem("High-tech buyer", "gmcc_flyers_hub_hightech", null, [
          getItem("GMCC - Thunder", "gmcc_thunder"),
          getItem("GMCC - Fabulous jumbo", "gmcc_fabulous_jumbo"),
          getItem("GMCC - Amazing jumbo", "gmcc_amazing_jumbo"),
          getItem("GMCC - Celebrity jumbo", "gmcc_affluent_celebrity_20_low_rate"),
        ]),
        getItem("High-net-worth clients", "gmcc_flyers_hub_highnetworth", null, [
          getItem("Asset as income", "gmcc_flyers_hub_asset", null, [
            getItem("GMCC - Celebrity", "gmcc_asset_as_income"),
            getItem("GMCC - Neptune", "gmcc_neptune"),
            getItem("GMCC - Mercury", "gmcc_mercury"),
          ]),
          getItem("GMCC - Massive", "gmcc_massive"),
          getItem("GMCC - DSCR", "gmcc_dscr"),
        ]),
        getItem("Rental investors", "gmcc_flyers_hub_rental", null, [
          getItem("GMCC - DSCR", "gmcc_dscr"),
          getItem("GMCC - 10% Bank statement ($3M)", "gmcc_10percent_bank_statement"),
        ]),
        getItem("Self employed borrowers", "gmcc_flyers_hub_selfemployed", null, [
          getItem("GMCC - 10% Bank statement ($3M)", "gmcc_10percent_bank_statement"),
          getItem("GMCC - Hermes (Alternatives)", "gmcc_hermes_alternatives"),
          getItem("GMCC - Ocean", "gmcc_ocean"),
        ]),
        getItem("Community lending", "gmcc_flyers_hub_fthb", null, [
          getItem("GMCC - Celebrity $10K grant", "gmcc_free_10k"),
          getItem("GMCC - Celebrity Forgivable $10K", "gmcc_forgivable_10k"),
          getItem("GMCC - Jumbo CRA Program - with Rates", "gmcc_jumbo_cra_program"),
          getItem("GMCC - Diamond Community", "gmcc_diamond_community_lending"),
          getItem("GMCC - Grandslam", "gmcc_grandslam"),
          getItem("GMCC - Conforming special", "gmcc_conforming_special"),
        ]),
        getItem("Others", 'gmcc_flyers_hub'),
      ]),
      getItem("Celebrity", "gmcccelebrityrates"), 
      getItem("Universe", 'gmccuniverserates'),
      getItem("Diamond", 'gmccdiamond'),
      getItem("One Page App Setup", "gmcc_encompass_setup"),
      checkAccess([UR_Owner, UR_LoanOfficerManager]) && getItem("Flyer rates setup", "flyer_rates_setup")
    ],
    "group"
  ),
];

const GMCCCalculators = (props) => {
  const [selectedKey, setSelectedKey] = useState("gmcc_flyers_hub_openhouse")
  const [current, setCurrent] = useState(<Borrowers />);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const location = useLocation();
  useEffect(() => {

    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);
    const queryParams = new URLSearchParams(location.search);
    const hasParam = queryParams.has('select');
    if (hasParam) {
      const params = {
        key: queryParams.get('select')
      }
      onClick(params)
    } else {

      onClick({

        key: sessionStorage.getItem('path') === undefined ? 'gmcc_flyers_hub_openhouse' : sessionStorage.getItem('path')
      })
    }
    return () => {
      window.removeEventListener('resize', handleResize);

    };
  }, []);

  const [showUser, setShowUser] = useState(null)
  useEffect(() => {

    if (showUser === null) return
    onClick({ key: 'usermanagement' })
  }, [

    showUser
  ])

  const visitCelebrityfromProgramMap = () => {
    setSelectedKey("gmcccelebrityrates")
    sessionStorage.setItem('path', "gmcccelebrityrates")
    setCurrent(<RateQuote isGMCCCelebrity={true} />);
  }

  const onClick = (e) => {
    setSelectedKey(e.key)
    sessionStorage.setItem('path', e.key)
    switch (e.key) {
      case "programengine":
        setCurrent(<GMCCProgramEngine gotoCelebrity={visitCelebrityfromProgramMap} />);
        break;
      //luxury open house
      case "gmcc_universe":
        setCurrent(<GMCCFlyersHub subgroup={e.key} />);
        break;
      case "gmcc_massive":
        setCurrent(<GMCCFlyersHub subgroup={e.key} />);
        break;
      case "gmcc_radiant_no_income_doc":
        setCurrent(<GMCCFlyersHub subgroup={e.key} />);
        break;
      case "gmcc_diamond_aus":
        setCurrent(<GMCCFlyersHub subgroup={e.key} />);
        break;
      case "gmcc_buy_without_sell_first":
        setCurrent(<GMCCFlyersHub subgroup={e.key} />);
        break;
      case "gmcc_10percent_bank_statement":
        setCurrent(<GMCCFlyersHub subgroup={e.key} />);
        break;
      //asset as income
      case "gmcc_asset_as_income":
        setCurrent(<GMCCFlyersHub subgroup={e.key} />);
        break;
      case "gmcc_neptune":
        setCurrent(<GMCCFlyersHub subgroup={e.key} />);
        break;
      case "gmcc_mercury":
        setCurrent(<GMCCFlyersHub subgroup={e.key} />);
        break;
      //high-tech buyer
      case "gmcc_thunder":
        setCurrent(<GMCCFlyersHub subgroup={e.key}/>);
        break;
      case "gmcc_fabulous_jumbo":
        setCurrent(<GMCCFlyersHub subgroup={e.key}/>);
        break;
      case "gmcc_amazing_jumbo":
        setCurrent(<GMCCFlyersHub subgroup={e.key}/>);
        break;
      case "gmcc_affluent_celebrity_20_low_rate":
        setCurrent(<GMCCFlyersHub subgroup={e.key}/>);
        break;
      //high-net-worth clients
      case "gmcc_dscr":
        setCurrent(<GMCCFlyersHub subgroup={e.key}/>);
        break;
      //real estate/rental investor
      //self employed borrowers
      case "gmcc_hermes_alternatives":
        setCurrent(<GMCCFlyersHub subgroup={e.key}/>);
        break;
      case "gmcc_ocean":
        setCurrent(<GMCCFlyersHub subgroup={e.key}/>);
        break;
      //first-time homebuyers
      case "gmcc_free_10k":
        setCurrent(<GMCCFlyersHub subgroup={e.key}/>);
        break;
      case "gmcc_diamond_community_lending":
        setCurrent(<GMCCFlyersHub subgroup={e.key}/>);
        break;
      case "gmcc_grandslam":
        setCurrent(<GMCCFlyersHub subgroup={e.key}/>);
        break;
      case "gmcc_jumbo_cra_program":
        setCurrent(<GMCCFlyersHub subgroup={e.key}/>);
        break;
      case "gmcc_forgivable_10k":
        setCurrent(<GMCCFlyersHub subgroup={e.key}/>);
        break;
      case "gmcc_conforming_special":
        setCurrent(<GMCCFlyersHub subgroup={e.key}/>);
        break;
      case "gmcc_flyers_hub":
        setCurrent(<GMCCFlyersHub subgroup="gmcc_jumbo_express" combineMode={true}/>);
        break;
      case "gmcccelebrityrates":
        setCurrent(<RateQuote isGMCCCelebrity={true} />);
        break;
      case "gmccuniverserates":
        setCurrent(<GMCCUniverseCalculator />);
        break;
      case "gmccdiamond":
        setCurrent(<GMCCDiamond />);
        break;
      case "flyer_rates_setup":
        setCurrent(<FlyerRatesSetup />);
        break;
      case "gmcc_encompass_setup":
        setCurrent(<EncompassSetup />);
        break;
      default:
        break;
    }
  };

  return (
    <div className={isMobile ? "mobileManagementWrap" : "managementWrap"}>
      <Menu
        onClick={onClick}
        className={isMobile ? "mobileManagementMenu" : "managementMenu"}
        selectedKeys={[selectedKey]}
        mode={isMobile ? "horizontal" : "inline"}
        items={items}
        style={isMobile ? undefined :{minWidth: 250, maxWidth: 250}}
        defaultOpenKeys={["gmcc_flyers_hub"]}
      />
      <div className={selectedKey === "programengine" || selectedKey==="gmcccelebrityrates"? "programEnginePane":"w-100"}>{current}</div>
    </div>
  );
};

export default GMCCCalculators;
